export const CLAIMS_ACTIVITY = 'claimsActivity'
export const NOTES = 'notes'
export const CLAIM_OUTBOUND_EMAIL = 'claimOutboundEmail'
